module.exports = __webpack_public_path__ + "img/mallasombra.889f2fb2.jpeg";